// extracted by mini-css-extract-plugin
export default {"control":"pricingInfo_control__PenLd","row":"pricingInfo_row__ufp01","label":"pricingInfo_label__TAWUy"};